/*
 * @Author: wangkai 1148506760@qq.com
 * @Date: 2023-01-15 16:53:17
 * @LastEditors: wangkai 1148506760@qq.com
 * @LastEditTime: 2023-01-15 16:54:33
 * @FilePath: \hallportal-web\pc\src\api\management\system.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/http";
export function getSystemConfig() {
  return request({
    url: "/admin/sys/config",
    method: "get",
  });
}
export function updateSystemConfig(params) {
  return request({
    url: "/admin/sys/config/update",
    method: "POST",
    data: params,
  });
}
